import type { Meta, StoryObj } from "@storybook/react";

import type { IconProps } from "@/ui/core";
import { Icon, Text } from "@/ui/core";
import type { IconSize } from "@/ui/core/Icon";
import { FAIconName } from "@/ui/core/Icon";
import { HStack, VStack } from "@/ui/layout";

const IconSizeValues: Record<IconSize, IconSize> = {
  lg: "lg",
  md: "md",
  sm: "sm",
  xs: "xs",
};

const StoryMeta: Meta<IconProps> = {
  title: "Core/Icon",
  component: Icon,
  argTypes: {
    color: {
      control: "color",
    },
    name: {
      control: "select",
      options: Object.values(FAIconName),
    },
    size: {
      control: "select",
      options: Object.values(IconSizeValues),
    },
    testID: { control: "text" },
  },
  args: {
    name: FAIconName.BookOpenReader,
    size: "md",
    testID: "storybook",
  },
};

type Story = StoryObj<IconProps>;

const Primary: Story = {};

const Icons: Story = {
  ...StoryMeta,
  render: (args) => {
    const { color, size } = args;
    return (
      <HStack flexWrap="wrap" gap={30}>
        {Object.values(FAIconName).map((name) => (
          <VStack gap={6} key={name}>
            <Text testID={name} variant="caption">
              {name}
            </Text>
            <Icon
              color={color}
              key={name}
              name={name}
              size={size}
              testID={name}
            />
          </VStack>
        ))}
      </HStack>
    );
  },
};

export { Icons, Primary };
export default StoryMeta;
